import {ProjectControlItem} from '../_models';
import {Recurring} from './index';
import * as moment from 'moment';

export class DatesHelper {

  public static getDates(projectControlItem: ProjectControlItem, maxDate: moment.Moment = moment().startOf('day'), dueDate: moment.Moment = null): any[] {
    let i;
    let date;
    dueDate = dueDate || moment(projectControlItem.dueDate).utc();
    if (projectControlItem.recurring == Recurring.None) {
      date = moment(dueDate).utc();
      if (!date.isValid() || date.get('year') < 1900) date = moment();
      return [{label: date.format('l'), value: date.startOf("day").format('Y-MM-DDT00:00:00'), date: date.clone()}];
    }


    const ranges = [];
    const currentDate = moment(dueDate).startOf('day');
    const oldRanges = (projectControlItem.completionPeriods.filter(x => !x.temporary) || []).map(i => i.dueDate);

    for (i = 0; i < oldRanges.length; i++) {
      if (oldRanges[i]) {
        date = moment(oldRanges[i]).local();
        ranges.push({label: date.format('l'), value: date.startOf("day").format('Y-MM-DDT00:00:00'), date: date.clone()});
        /*if (currentDate.isSameOrBefore(date)) {
          currentDate = date;
        }*/
      }
    }

    let futureNumber = 0;
    const nowTime = moment().startOf('day');
    let safeIterations = 0;

    while ((futureNumber < 3 || moment(maxDate).startOf('day').isSameOrAfter(currentDate)) && safeIterations < 10000) {
      safeIterations++;
      if (!ranges.find(r => r.value  == currentDate.format('Y-MM-DDT00:00:00'))) {
        ranges.unshift({
          label: currentDate.format('l'),
          value: currentDate.format('Y-MM-DDT00:00:00'),
          date: currentDate.clone()
        });
        if (currentDate.isSameOrAfter(nowTime)) futureNumber++;
      }
      if (projectControlItem.recurring == Recurring.Daily) {
        currentDate.add(1, 'day');
      } else if (projectControlItem.recurring == Recurring.Weekly) {
        currentDate.add(1, 'week');
      } else if (projectControlItem.recurring == Recurring.Monthly) {
        currentDate.add(1, 'month');
      } else if (projectControlItem.recurring == Recurring.Quarterly) {
        currentDate.add(3, 'month');
      } else if (projectControlItem.recurring == Recurring.Yearly) {
        currentDate.add(1, 'year');
      }
    }
    ranges.sort((a, b) => a.date.valueOf() - b.date.valueOf());

    return ranges;
  }

  public static IsAllCompleted(projectControlItem: ProjectControlItem, maxDate: moment.Moment): boolean
  {
    const dates = DatesHelper.getDates(projectControlItem, maxDate);
    const completedDates = projectControlItem.completionPeriods.filter(x => x.isCompleted).map(x => moment(x.dueDate));
    return dates.find(d => completedDates.find(c => c.isSame(d.date, 'day')) == null) == null;
  }

  public static IsCompletedNow(projectControlItem: ProjectControlItem): boolean
  {
    const next = DatesHelper.GetUpcomingDate(projectControlItem, false);
    const completedDates = projectControlItem.completionPeriods.filter(x => x.isCompleted).map(x => moment(x.dueDate));
    return completedDates.find(c => c.isSame(next.date, 'day')) != null;
  }

  public static GetUpcomingDate(projectControlItem: ProjectControlItem, skipCompleted: boolean): any
  {
    const now = moment().add(15, 'hour');
    const dates = DatesHelper.getDates(projectControlItem);
    const closest = dates.reverse().find(i => i.date.isSameOrAfter(now, 'day') && (!skipCompleted || !projectControlItem.completionPeriods.find(d => moment(d.dueDate).isSame(i.value))));
    const next = closest || dates[0];
    return next;
  }

  public static pad(number) {
    if (number < 10) {
      return '0' + number;
    }

    return number;
  }

  public static formatDate(date: Date) {

    return date.getFullYear() + '-' + DatesHelper.pad(date.getMonth() + 1) + '-' + DatesHelper.pad(date.getDate()) + 'T00:00:00';
  }
}
